import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import ListAndPaginate from './paginate';
import Header from './header';
import BottomFooter from './footer';
import Nav from './nav';
import ToTop from '../../components/toTop';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;
        const { header, footer, navigation, columnData, newsstream, columnId } = content;
        const navInfo =
            columnId === '1-75-95377-' ? (
                <Nav content={navigation} current={6} />
            ) : (
                <Nav content={navigation} current={12} />
            );

        return (
            <div>
                <Header content={header} />
                {navInfo}
                <div className={styles.w1180}>
                    <div className={styles.h2wrapper}>
                        <h2>{columnData.title}</h2>
                    </div>
                    <ListAndPaginate content={newsstream} />
                </div>
                <BottomFooter content={footer} />
                <ChipEdit />
            </div>
        );
    }
}

export default Layout;
